"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarketActivityType;
(function (MarketActivityType) {
    MarketActivityType[MarketActivityType["UNKNOWN"] = 0] = "UNKNOWN";
    MarketActivityType[MarketActivityType["POINT"] = 1] = "POINT";
    MarketActivityType[MarketActivityType["PREORDER"] = 2] = "PREORDER";
    MarketActivityType[MarketActivityType["NEW_POINT"] = 3] = "NEW_POINT";
    MarketActivityType[MarketActivityType["LIMITED_TIME_SALE"] = 4] = "LIMITED_TIME_SALE";
    MarketActivityType[MarketActivityType["RESERVATION"] = 5] = "RESERVATION";
    MarketActivityType[MarketActivityType["SLM_DISCOUNT"] = 6] = "SLM_DISCOUNT";
    MarketActivityType[MarketActivityType["GIFT_COURSE"] = 7] = "GIFT_COURSE";
    MarketActivityType[MarketActivityType["DOUBLE_11"] = 8] = "DOUBLE_11";
    MarketActivityType[MarketActivityType["SPECIFY_PURCHASE"] = 9] = "SPECIFY_PURCHASE";
    MarketActivityType[MarketActivityType["REFUND_PLUS"] = 10] = "REFUND_PLUS";
    MarketActivityType[MarketActivityType["CLOCK_IN"] = 11] = "CLOCK_IN";
    MarketActivityType[MarketActivityType["GROWTH_SHARE"] = 12] = "GROWTH_SHARE";
    MarketActivityType[MarketActivityType["REFUND_V4"] = 13] = "REFUND_V4";
})(MarketActivityType = exports.MarketActivityType || (exports.MarketActivityType = {}));
var ProductSpecificationAction;
(function (ProductSpecificationAction) {
    ProductSpecificationAction[ProductSpecificationAction["CONSTRAIN"] = 0] = "CONSTRAIN";
    ProductSpecificationAction[ProductSpecificationAction["COST"] = 1] = "COST";
    ProductSpecificationAction[ProductSpecificationAction["REWARD"] = 2] = "REWARD";
})(ProductSpecificationAction = exports.ProductSpecificationAction || (exports.ProductSpecificationAction = {}));
var ProductSpecificationType;
(function (ProductSpecificationType) {
    ProductSpecificationType[ProductSpecificationType["CASH"] = 0] = "CASH";
    ProductSpecificationType[ProductSpecificationType["POINT"] = 1] = "POINT";
    ProductSpecificationType[ProductSpecificationType["REDPACK"] = 2] = "REDPACK";
    ProductSpecificationType[ProductSpecificationType["COMPLETED_LESSON"] = 3] = "COMPLETED_LESSON";
    ProductSpecificationType[ProductSpecificationType["REFUND_PERCENTAGE"] = 4] = "REFUND_PERCENTAGE";
    ProductSpecificationType[ProductSpecificationType["BEFORE_COMPLETE_COURSE"] = 5] = "BEFORE_COMPLETE_COURSE";
})(ProductSpecificationType = exports.ProductSpecificationType || (exports.ProductSpecificationType = {}));
var EarnPointWay;
(function (EarnPointWay) {
    EarnPointWay[EarnPointWay["UNKNOWN"] = 0] = "UNKNOWN";
    EarnPointWay[EarnPointWay["SLM"] = 1] = "SLM";
    EarnPointWay[EarnPointWay["CHECK_IN"] = 2] = "CHECK_IN";
})(EarnPointWay = exports.EarnPointWay || (exports.EarnPointWay = {}));
var ExchangeStatus;
(function (ExchangeStatus) {
    ExchangeStatus[ExchangeStatus["TO_EXCHANGE"] = 0] = "TO_EXCHANGE";
    ExchangeStatus[ExchangeStatus["CUTOFF"] = 1] = "CUTOFF";
    ExchangeStatus[ExchangeStatus["NEW_USER_ONLY"] = 2] = "NEW_USER_ONLY";
    ExchangeStatus[ExchangeStatus["MEET_FULL_EXCHANGE_FULL"] = 3] = "MEET_FULL_EXCHANGE_FULL";
    ExchangeStatus[ExchangeStatus["MEET_FULL_EXCHANGE_HALF"] = 4] = "MEET_FULL_EXCHANGE_HALF";
    ExchangeStatus[ExchangeStatus["MEET_SCORE_EXCHANGE_HALF"] = 5] = "MEET_SCORE_EXCHANGE_HALF";
    ExchangeStatus[ExchangeStatus["EXCHANGED_HALF"] = 6] = "EXCHANGED_HALF";
    ExchangeStatus[ExchangeStatus["EXCHANGED"] = 7] = "EXCHANGED";
})(ExchangeStatus = exports.ExchangeStatus || (exports.ExchangeStatus = {}));
var EarnPoint;
(function (EarnPoint) {
    EarnPoint[EarnPoint["HORIZONTAL_ROW"] = 0] = "HORIZONTAL_ROW";
    EarnPoint[EarnPoint["VERTICAL_COLUMN"] = 1] = "VERTICAL_COLUMN";
})(EarnPoint = exports.EarnPoint || (exports.EarnPoint = {}));
//# sourceMappingURL=point.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/point.js
// module id = 1004
// module chunks = 0